import { useState, FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const hpField = formData.get('website_alt');
    if (hpField && String(hpField).trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9oodigsenbniolesis0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，最新漫画更新将第一时间通知您。');
        setEmail('');
      } else {
        const errMsg = (parsed as Record<string, unknown>)?.meta
          ? ((parsed as Record<string, unknown>).meta as Record<string, unknown>).message
          : '订阅失败，请稍后再试';
        setStatus('error');
        setMessage(String(errMsg || '订阅失败，请稍后再试'));
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请检查连接后重试。');
    }
  };

  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20cosmic%20nebula%20with%20soft%20golden%20starlight%2C%20ethereal%20space%20clouds%2C%20warm%20orange%20and%20subtle%20teal%20hues%2C%20peaceful%20galaxy%20scene%2C%20abstract%20space%20art%2C%20clean%20composition%2C%20no%20text&width=1600&height=600&seq=newsletter-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-black/50"></div>
      <div className="relative max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-24 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
          订阅<strong>星球漫画</strong>通讯
        </h2>
        <p className="text-sm text-background-200/80 mb-8 max-w-md mx-auto">
          第一时间获取最新<strong>科幻漫画</strong>更新、热门<strong>星际漫画</strong>推荐和独家阅读福利
        </p>
        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-md bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 placeholder:text-background-300 text-sm focus:outline-none focus:border-primary-400 transition-colors"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="hp-field"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 rounded-md font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>
        {status !== 'idle' && status !== 'loading' && (
          <p className={`mt-3 text-xs ${status === 'success' ? 'text-accent-300' : 'text-red-300'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}